import { Box, Button, Typography } from '@mui/material';

export default function CardOtherProducts({ logo, description, href }) {
	return (
		<Box
			sx={{
				width: { xs: '100%', md: '33%' },
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				flexDirection: 'column',
				backgroundColor: '#1D1D1D',
				padding: '16px 24px',
				gap: '32px',
				borderRadius: '16px',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
					gap: '16px',
				}}
			>
				<img
					src={logo}
					alt={description}
					style={{
						maxHeight: '140px',
					}}
				/>
				<Box
					sx={{
						width: { xs: '80%', md: '70%' },
					}}
				>
					<Typography
						color={'#CCCCCC'}
						variant={'h3'}
						fontFamily={'Poppins'}
						fontWeight={500}
						lineHeight={1.2}
						fontSize={'16px'}
						textAlign={'center'}
					>
						{description}
					</Typography>
				</Box>
			</Box>
			<Button
				variant={'contained'}
				onClick={() => (window.location.href = href)}
				sx={{
					borderRadius: 32,
					paddingX: 10,
					fontFamily: 'Poppins',
					fontSize: { xs: '12px', md: '16px' },
					color: '#FFFFFF',
					textTransform: 'none',

					backgroundColor: '#060502',
				}}
			>
				Saiba mais
			</Button>
		</Box>
	);
}
